import ShippingAddress from '../addresses/shippingAddress';
import HadrianBase from '../hadrianBase';

export default class SalesAgencyAddress extends HadrianBase {
  readonly organizationName: string;
  readonly address: ShippingAddress;
}
